import { Component, Inject, OnInit } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { map } from 'rxjs/operators';
import { CustomersService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
  
  latitude: number;
  longitude: number;
  zoom: number = 18;
  address: string = '';
  img: string[] = [];
  imageIndexOne: number = 0;
  isLoading: boolean = true;
  private geoCoder: any;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customersService: CustomersService,
    private mapsAPILoader: MapsAPILoader
  ) {}

  ngOnInit() {
    if (this.data.showWindow === "image") {
      this.isLoading = true;
      this.getImages();
    } else {
      this.latitude = this.data.transaction.Latitude;
      this.longitude = this.data.transaction.Longitude;
  
      this.mapsAPILoader.load().then(() => {
        if (window['google'] && window['google'].maps) {
          this.geoCoder = new window['google'].maps.Geocoder();
          this.getAddress(this.latitude, this.longitude);
        } else {
          console.error("Google Maps API not loaded");
        }
      }).catch(err => {
        console.error("Error loading Google Maps API", err);
      });
    }
  }

  getImages() {
    this.customersService.getImages(this.data.transaction)
      .pipe(map(res => {
        if (res.Status === 200) {
          this.img = res.data;
        }
      })).subscribe();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getAddress(latitude: number, longitude: number) {
    if (!this.geoCoder) return;
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results: any, status: any) => {
      if (status === 'OK') {
        if (results[0]) {
          this.address = results[0].formatted_address;
        } else {
          alert('No results found');
        }
      } else {
        alert('Geocoder failed due to: ' + status);
      }
    });
  }

  // Navigate to the previous image
  prevImage() {
    if (this.imageIndexOne > 0) {
      this.imageIndexOne--;
    }
  }

  // Navigate to the next image
  nextImage() {
    if (this.imageIndexOne < this.img.length - 1) {
      this.imageIndexOne++;
    }
  }

  // Download the current image
  downloadImage() {
    if (this.img.length === 0) return;
    const a = document.createElement('a');
    a.href = this.img[this.imageIndexOne];
    a.download = 'downloaded-image.jpg';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
